import { render, staticRenderFns } from "./GestioneAttivitaTasksListComponent.vue?vue&type=template&id=094f9a1d"
import script from "./GestioneAttivitaTasksListComponent.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaTasksListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports